import { render, staticRenderFns } from "./icon-plus.vue?vue&type=template&id=0a05e67c&scoped=true&"
import script from "./icon-plus.vue?vue&type=script&lang=js&"
export * from "./icon-plus.vue?vue&type=script&lang=js&"
import style0 from "./icon-plus.vue?vue&type=style&index=0&id=0a05e67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05e67c",
  null
  
)

export default component.exports